<template>
  <div id="topNav">
    <div class="topNav-wrap">
      <div class="topNav-container container">
        <router-link class="branding-logo" to="/">
          <img src="../../../public/FullLogoV3.webp" alt />
          <h3>Pediatric Health Consultants</h3>
        </router-link>
        <ul class="user-info">
          <li>
            <div class="right">
              <p class="username">{{ fullname }}</p>
              <p class="role" v-if="isAdmin">Admin</p>
              <p class="role" v-else>Standard User</p>
            </div>
            <div class="left">
              <p class="user-initials">{{initials}}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from "../mixins/getUserInfo";
export default {
  name: "TopNav",
  mixins: [getUserInfo],
};
</script>

<style lang="scss">
#topNav {
  background-color: white;
  padding: 0.7rem 0;
  border-bottom: 2px solid #f1f1f1;

  img {
    margin-right: 0.5rem;
    height: 46px;
  }

  .topNav-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
    text-align: center;

    @media (min-width: 700px) {
      flex-direction: row;
    }
  }

  .branding-logo {
    flex-wrap: wrap;
    margin: 1rem 0;
    flex: 1;
    align-items: center;
    justify-content: center;
    display: flex;
    color: #979797;
    text-decoration: none;

    img {
      margin-bottom: 1rem;
    }

    @media (min-width: 445px) {
      justify-content: initial;

      img {
        margin-bottom: 0;
      }
    }
  }

  .user-info {
    list-style: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #979797;

    li {
      display: flex;
      align-items: center;
    }

    .right {
      order: 2;
    }

    .left {
      order: 1;
      margin-right: 0.5rem;

      img {
        border-radius: 50%;
        height: 46px;
        width: 46px;
      }

      .user-initials {
        color: white;
        margin-right: 0.5rem;
        padding: 10px;
        border-radius: 50%;
        background-color: #6338ff;
        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
          0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
      }
    }

    .username {
      cursor: pointer;
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 0.2rem;
    }

    .role {
      font-size: 12px;
      text-align: left;
      font-weight: 300;
    }
  }

  h3 {
    font-size: 24px;
  }
}
</style>
